import Wrapper from "./Wrapper";
import Modal from "./Modal";
import Confirm from "./Confirm";
import ResetPassword from "./ResetPassword";

export default {
  Wrapper,
  Modal,
  Confirm,
  ResetPassword
};
